export default {
  path: 'contacts',
  name: 'vendor/contacts',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "vendor-show-contacts" */ './ContactsTab')
}
